import get from 'lodash/get';

import { DISPLAY_PARAM_REGEXP } from '../constants';

export default function hasDisplayPageParams(state: object) {
  const search = get(state, 'router.location.search');
  const regexp = new RegExp(DISPLAY_PARAM_REGEXP);
  return regexp.test(search);
}
